import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const invite = {
  getClientId() {
    return store.getters['Client/clientId']
  },
  create(invite, locationId) {
    return Axios.post(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/locations/${locationId}/invites`, invite,{
      ignoreGlobalCatch: true,
    })
  }
}

export default invite
